<script setup>
// Pestañas de la sucursal PERSONAL (Victor 2026-06-05 · P2 "subrayado dorado").
// Estilo delicado: solo texto + ícono en una línea, subrayado dorado en la activa,
// sin caja y sin "Más" — los 4 filtros (Todos · Grupos · Tareas · Cerrados) siempre
// visibles y repartiendo el ancho. Igual de fino en celular y en PC.
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: 'all',
  },
});

const emit = defineEmits(['chatTabChange']);

function select(key, activeTab) {
  if (key !== activeTab) emit('chatTabChange', key);
}
</script>

<template>
  <div class="w-full px-3 pt-1">
    <div class="flex border-b border-n-weak">
      <button
        v-for="item in items"
        :key="item.key"
        type="button"
        class="flex-1 flex items-center justify-center gap-1 px-1 py-2 text-[11px] font-medium whitespace-nowrap border-b-2 -mb-px transition-colors"
        :class="item.key === activeTab
          ? 'text-[#d4b87a] border-[#c9a35a]'
          : 'text-n-slate-11 border-transparent hover:text-n-slate-12'"
        @click="select(item.key, activeTab)"
      >
        <span class="truncate">{{ item.name }}</span>
        <span
          v-if="item.key === activeTab && item.count !== undefined && item.count !== null"
          class="text-[9px] font-bold text-[#c9a35a]"
        >{{ item.count.toLocaleString('es-DO') }}</span>
      </button>
    </div>
  </div>
</template>
